export default __webpack_public_path__ + "static/frog-sitting-49e1e5e60a2275bd2ffb405a1859a2ff.webp";